module.exports = __webpack_public_path__ + "img/bt-espace-client.d65ee37f.svg";